import React from 'react';

interface FraudModalProps {
    onCloseClickListener: () => void;
}

const FraudModal = ({ onCloseClickListener }: FraudModalProps) => {
    return (
        <>
            <div id="fraudModal" className="fraud-modal" tabIndex={-1} role="dialog" aria-labelledby="">
                <div className="fraud-modal__content">
                    <button type="button" className="fraud-modal__content__close-btn" data-dismiss="modal" aria-label="Close" onClick={onCloseClickListener}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                        >
                            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                                <g transform="translate(-918 -186)">
                                    <path fill="#FFF" d="M0 0H1200V912H0z"></path>
                                    <g
                                        stroke="#000"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                    >
                                        <g transform="translate(264 175)">
                                            <g transform="translate(654 11)">
                                                <g transform="translate(1 1)">
                                                    <path d="M0.286 0.286L11.714 11.714"></path>
                                                    <path
                                                        d="M0.286 0.286L11.714 11.714"
                                                        transform="matrix(-1 0 0 1 12 0)"
                                                    ></path>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </button>
                    <h4 className="fraud-modal__content__title">We&apos;re sorry for the inconvenience</h4>
                    <div className="fraud-modal__content__body">
                        <p>
                            TSC.ca will not be able to process your request at this time due to the status of
                            your account.
                        </p>
                        <p>
                            For more information regarding your account, please contact our Customer Service
                            Center at 1-888-2020-888
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FraudModal;
